import axios from 'axios';

import {
  ADD_DIALOGUE,
  GET_ERRORS,
  CLEAR_ERRORS,
  GET_DIALOGUES,
  GET_DIALOGUE,
  DIALOGUE_LOADING,
  DELETE_DIALOGUE
} from './types';

// Add Dialogue
export const addDialogue= dialogueData => dispatch => {
  dispatch(clearErrors());
  axios
    .post('/api/dialogue/add', dialogueData)
    .then(res =>
      dispatch({
        type: ADD_DIALOGUE,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};
//
export const logIn = () => dispatch => {
  var config = {
    headers: {'appkey': 'cclmagic2019'}
  };
  axios
    .get(`/static/audio/`,config)
    .then(res => {
      console.log(res)
  })
}
// Get Dialogues
export const getDialogues = () => dispatch => {
  dispatch(setDialogueLoading());

  axios
    .get('/api/dialogues')
    .then(res =>
      dispatch({
        type: GET_DIALOGUES,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_DIALOGUES,
        payload: null
      })
    )
};


export const allDialogues = async () => {
  return axios.get('/api/dialogues');
};

// Get Dialogue
export const getDialogue = id => dispatch => {
  dispatch(setDialogueLoading());
  axios
    .get(`/api/dialogues/${id}`)
    .then(res =>
      dispatch({
        type: GET_DIALOGUE,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_DIALOGUE,
        payload: null
      })
    );
};

export const saveOrUpdate = (data) => {
  data.token = "cclmagicS1T2";
  if (data._id) {
    return axios.post('/api/dialogues/update', data); 
  }
  return axios.post('/api/dialogues/add', data);
}

export const deleteDialogue = (id) => {
  return axios.delete(`/api/dialogues/${id}`); 
}

// Set loading state
export const setDialogueLoading = () => {
  return {
    type: DIALOGUE_LOADING
  };
};

// Clear errors
export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS
  };
};
